import { ViewIds } from '@ardoq/api-types';
import { exhaustiveCheck } from '@ardoq/common-helpers';
import { isViewWithoutFullyMultiLabelsSupport } from 'views/environmentals/getViewpointModeSupportedViews';
import { hasReferenceBubbleChartFeature } from 'tabview/bubbleChart/referenceBubbleChart/hasReferenceBubbleChartFeature';

export const getRestrictedMultilabelFormattingWarningMessage = (
  viewId: ViewIds
) => {
  if (!isViewWithoutFullyMultiLabelsSupport(viewId)) {
    return undefined;
  }

  switch (viewId) {
    case ViewIds.BLOCKS:
      return 'Interactive Blocks view style shows reference labels when you hover on the reference';
    case ViewIds.RELATIONSHIPS_3:
      return 'Relationships view style only shows the first field for each component and reference type.';
    case ViewIds.TIMELINE:
      return 'Reference labels are not shown in Timeline view.';
    case ViewIds.BUBBLE:
      return hasReferenceBubbleChartFeature()
        ? 'Bubble Chart view style only shows the first field for each component and reference type. Reference labels are only shown when Source of values is a reference.'
        : 'Bubble Chart view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    /* Stronger than the "first field" the four above warn about: these take only the component's
       name and drop every configured label, because a tile, a circle and a ring have no room
       beneath one. They draw no references either. */
    case ViewIds.HIERARCHICAL_TREEMAP:
      return 'Hierarchical Treemap view style shows only the component name. Field labels and reference labels are not shown in this view style.';
    case ViewIds.HIERARCHICAL_PACKING:
      return 'Hierarchical Circle Packing view style shows only the component name. Field labels and reference labels are not shown in this view style.';
    case ViewIds.SUNBURST:
      return 'Sunburst view style shows only the component name. Field labels and reference labels are not shown in this view style.';
    case ViewIds.SURFACE_3D:
      return '3D Surface view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.CONTOUR:
      return 'Contour Chart view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.SPIDER_2:
      return 'Spider Chart view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.POLAR:
      return 'Polar Chart view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.SCATTER_3D:
      return '3D Scatter view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.BUBBLE_3D:
      return '3D Bubble view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    case ViewIds.NETWORK_3D:
      return '3D Network view style only shows the first field for each component type. Reference labels are not shown in this view style.';
    default:
      return exhaustiveCheck(viewId);
  }
};
